import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Spinner, Alert, Form } from 'react-bootstrap';
import axios from 'axios';

const BuyCreditsPage = () => {
  const [appointmentAmount, setAppointmentAmount] = useState(200); // Inicia com 200
  const [pricePerAppointment, setPricePerAppointment] = useState(0.11);
  const [totalPrice, setTotalPrice] = useState('0.00');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const packages = [200, 400, 600, 800, 1000, 2000]; // Pacotes de 50 em 50

  useEffect(() => {
    // Define o preço por créditos com base na quantidade selecionada
    const currentPrice = appointmentAmount >= 401 ? 0.12 : 0.15;
    setPricePerAppointment(currentPrice);

    // Calcula o preço total
    const calculatedPrice = appointmentAmount * currentPrice;
    setTotalPrice(calculatedPrice.toFixed(2));
  }, [appointmentAmount]);

  const handleCreatePaymentLink = async () => {
    if (appointmentAmount <= 0) {
      setError('A quantidade de créditos deve ser maior que zero.');
      return;
    }
    setError(null);
    setIsLoading(true);

    try {
      const response = await axios.post('/api/subscriptions/purchase-extra', { 
        amount: appointmentAmount,
        value: parseFloat(totalPrice)
      });
      
      // Redireciona o usuário para a URL de pagamento do Pagar.me
      if (response.data && response.data.payment_url) {
        window.location.href = response.data.payment_url;
      } else {
        setError('Não foi possível gerar o link de pagamento. Tente novamente.');
      }

    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Falha ao criar o link de pagamento. Tente novamente mais tarde.';
      setError(errorMsg);
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center align-items-center">
        <Col md={8} lg={6}>
          <Card className="shadow-sm">
            <Card.Body className="p-4 p-md-5">
              <div className="text-center mb-4">
                <h2 className="fw-bold">Comprar Créditos Extras</h2>
                <p className="text-muted">
                  Ficou sem créditos? Adicione créditos à sua conta de forma avulsa.
                  A compra é única e não altera sua assinatura recorrente.
                </p>
              </div>

              {error && <Alert variant="danger">{error}</Alert>}

              <div className="mb-4">
                <Form.Label className="text-center d-block mb-3">Escolha um Pacote mais viável para o momento de seu negócio:</Form.Label>
                <div className="d-flex flex-wrap justify-content-center gap-2">
                  {packages.map(pkgAmount => (
                    <Button
                      key={pkgAmount}
                      variant={appointmentAmount === pkgAmount ? 'primary' : 'outline-primary'}
                      onClick={() => setAppointmentAmount(pkgAmount)}
                      className="flex-grow-1"
                    >
                      {pkgAmount}
                    </Button>
                  ))}
                </div>
              </div>

              <div className="text-center bg-light rounded p-3 my-4">
                <p className="mb-1 text-muted">Valor Total a Pagar:</p>
                <p className="h2 fw-bold text-primary">R$ {String(totalPrice).replace('.', ',')}</p>
                {/* <small className="text-muted">Custo de R$ {String(pricePerAppointment.toFixed(2)).replace('.', ',')} por créditos.</small> */}
              </div>

              <div className="d-grid">
                <Button variant="primary" size="lg" onClick={handleCreatePaymentLink} disabled={isLoading || appointmentAmount <= 0}>
                  {isLoading ? <><Spinner as="span" animation="border" size="sm" className="me-2" /> Gerando Link...</> : 'Ir para Pagamento'}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BuyCreditsPage;